// CUSTOMER PROFILE COMPONENTS DICTIONARY
// https://medium.com/@pratikpatel_60309/dynamic-importing-component-templates-with-vue-js-78d2167db1e7
export const customersProfileComponents = [
    {
        text: "People",
        icon: "people",
        name: "users",
        import: () => import("Modules/companies/customers/components/Users.vue"),
        permission: "",
    },
    {
        text: "Parts",
        icon: "memory",
        name: "parts",
        import: () => import("Modules/companies/customers/components/Parts.vue"),
        perms: ["parts.read"],
    },
    {
        text: "Settings",
        icon: "settings",
        name: "settings",
        import: () => import("Modules/companies/customers/components/Settings.vue"),
        permission: "",
    },
];
